import { PureComponent } from 'preact-compat'
import Button from '../../../../uikit/Button'
import { ReportedContent } from './Report'

/* eslint-disable import/no-internal-modules */
import Modal, {
  ModalHeader,
  ModalBody,
  ModalFooter
} from '@insided/deprecated-preact-components/design-system-components/modal'
import UserAvatar from '@insided/deprecated-preact-components/User/UserAvatar'
import InputUnit from '@insided/deprecated-preact-components/design-system-components/input-unit'
import TextArea from '@insided/deprecated-preact-components/design-system-components/text-area'
import ListGroup from "@insided/deprecated-preact-components/design-system-components/list-group";
import Chip from '@insided/deprecated-preact-components/design-system-components/chip'
import Form from '@insided/deprecated-preact-components/design-system-components/form'
import { getInsidedData } from '@insided/destination/utils/insidedDataStorage'
import { t } from '@insided/deprecated-libs/translationsUtils/translations'

interface ResolveModalState {
  newMessage: string
}

interface ResolveModalProps {
  error?: string
  onResolve: (usernames: string[], message: string) => void
  onClose: () => void
  reportedContent: ReportedContent[]
  topicTitle: string
}

class ResolveModal extends PureComponent<ResolveModalProps, ResolveModalState> {
  constructor(props: ResolveModalProps) {
    super(props)

    this.state = {
      newMessage: t('Control', 'topic_moderation.reported_content.resolve.private_message', { topicTitle: props.topicTitle })
    }
  }

  handleChange = (message: string) => {
    this.setState({ newMessage: message })
  }

  render() {
    const { onResolve, onClose, reportedContent, error } = this.props
    const { newMessage } = this.state

    const user = getInsidedData('user')
    const filteredReportedContent = reportedContent?.filter(({ reportedBy }) => reportedBy.username !== user.name)
    const usernames = filteredReportedContent?.map(({ reportedBy }) => reportedBy.username) ?? []

    return (
      <Modal onClose={onClose} isControl>
        <ModalHeader title='Resolve reported content' />
        <ModalBody>
          {usernames.length === 0
            ? 'The selected report(s) will not be shown on the topic page anymore.'
            : (
              <Form>
                <div>
                  By resolving the reported content, the user(s) who reported this post will be notified via a private
                  message. You may modify the message below. Subsequently, the report(s) will not be shown on the topic page.
                </div>
                <InputUnit label='To'>
                  <div className='resolve-modal-metadata-container'>
                    <ListGroup spacing="8px">
                      {filteredReportedContent.map(({ id, reportedBy }) => {
                        return (
                          <Chip
                            key={id}
                            variant='squared'
                            size='small'
                            startIcon={<UserAvatar
                              user={{
                                ...reportedBy,
                                name: reportedBy.username,
                                url: `/member/profile/?userid=${reportedBy.id}`
                              }}
                              style={{ width: '20px', height: '20px' }}
                              openInNewTab
                            />}
                          >
                            {reportedBy.username}
                          </Chip>
                        )
                      })}
                    </ListGroup>
                  </div>
                </InputUnit>
                <InputUnit label='Message' error={error ?? undefined}>
                  <TextArea
                    onContentChange={this.handleChange}
                    value={newMessage}
                    verticalResize
                    size='fullWidth'
                    maxLength={250}
                  />
                </InputUnit>
              </Form>
            )
          }
        </ModalBody>
        <ModalFooter>
          <Button title='Resolve' variant='success' onClick={() => onResolve(usernames, newMessage)} size='medium' />
          <Button title='Cancel' onClick={onClose} size='medium' />
        </ModalFooter>
      </Modal>
    )
  }
}
export default ResolveModal
